import React from "react";
import { Heading, Tag } from "react-bulma-components";

function FilterSummary(props) {
  return (
    <Heading>
      <Tag.Group>
        <Tag>{props.tier}</Tag>
        <Tag>{props.dma}</Tag>
      </Tag.Group>
    </Heading>
  );
}

export default FilterSummary;
